<div class="mt-3">
  <table class="table table-striped text-center">
    <tbody>
      <tr>
        <td><a class="howtobuylink vx-cursor" queryParamsHandling="merge" routerLink="/company/contactus"
            [queryParams]="{ issue: 'sales', comments: 'requestademo' }">{{ 'HOWTOBUYNESTED.DEMO' | translate }}</a>
        </td>
        <td><a class="howtobuylink vx-cursor" queryParamsHandling="merge" routerLink="/company/contactus"
            [queryParams]="{ issue: 'sales', comments: 'howtobuy' }">{{ 'HOWTOBUYNESTED.SALES' | translate }}</a></td>
      </tr>
      <tr>
        <td><a class="howtobuylink vx-cursor" queryParamsHandling="merge" routerLink="/company/contactus"
            [queryParams]="{ issue: 'sales', comments: 'requestaquote' }">{{ 'HOWTOBUYNESTED.QUOTE' | translate }}</a>
        </td>
        <td>
          <!-- <a class="howtobuylink" queryParamsHandling="merge"
            routerLink="/company/financing">{{ 'HOWTOBUYNESTED.FINANCING' | translate }}</a> -->
          </td>
      </tr>
      <tr>
        <td><a class="howtobuylink" queryParamsHandling="merge"
            routerLink="/support/productregistration">{{ 'HOWTOBUYNESTED.REGISTER' | translate }}</a></td>
        <td><span class="howtobuylink vx-cursor blue"
            (click)="locate()">{{ 'HOWTOBUYNESTED.LOCATE' | translate }}</span></td>
      </tr>
    </tbody>
  </table>
  <div class="mb-2">
    <div *ngIf="countries" id="countryselect" class="">
      <div class="row">
        <label class="col-3 col-form-label small selectlabel">{{ 'LOCATEAPARTNER.SELECTC' | translate }}</label>
        <div class="col">
          <select (change)="chooseCountry()" type="text" class="form-control form-select form-select-sm shadow-sm"
            name="country" [(ngModel)]="countryCode">
            <option disabled selected> </option>
            <option *ngFor="let country of countries;" [value]="country.country_name">{{country.country_name}}</option>
          </select>
        </div>
      </div>
    </div>
    <div *ngIf="countryCode == 'USA' || countryCode == 'United States (USA)'" id="stateselect" class="">
      <div class="row">
        <label class="col-3 col-form-label small selectlabel">{{ 'LOCATEAPARTNER.SELECTS' | translate }}</label>
        <div class="col">
          <select (change)="chooseState()" name="stateselect" [(ngModel)]="stateCode"
            class="form-control form-select form-select-sm shadow-sm">
            <option disabled selected> </option>
            <option *ngFor="let state of stateOptions" [value]="state.value">{{ state.label }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <h4 *ngIf="reps && reps.length > 0" class="vx-section-header h4" id="partner">{{ 'LOCATEAPARTNER.LOCAL' | translate }}</h4>
  <div *ngIf="reps && reps.length > 0" class='row mt-3'>
    <div *ngFor="let rep of reps; let i = index" class='col-md-12 col-lg-6 my-3'>
      <div class='card vx-howtobuy-card h-100 shadow-sm'>
        <p class='d-block text-center lead mb-0 px-3 mt-3 blue'>{{ rep.Countries }}</p>
        <p class='d-block text-center lead mb-0 px-3 blue show' id="USlocation">{{ rep.Location }}</p>
        <!-- <p class="text-center small mb-0 text-body-secondary px-3">{{ rep.TechnologyFocus }}</p> -->
        <hr class="mb-0">
        <div class='card-body'>
          <p *ngIf="rep.CompanyName" class="lead fw-bold mb-0"><u>{{ 'LOCATEAPARTNER.LOCALC' | translate }}</u></p>
          <p class="mb-0 fw-bold">{{ rep.CompanyName }}</p>
          <!-- <p id="{{'repemail' + i}}" class="mb-0 show"><a href="mailto:{{ rep.LocalContactEmail }}?subject=VeEX:%20Locate%20a%20Partner%20Inquiry%20|%20{{ currentURL }}">{{ rep.LocalContactEmail }}</a></p> -->
          <span id="{{'repemail' + i}}" class="mb-0 show align-middle" [innerHTML]="rep.LocalContactEmail">
          </span>
          <!-- <p id="{{'repwebsite' + i}}" class="mb-0 show"><a href="{{rep.LocalContactWebsite}}"
              target="_blank">{{ rep.LocalContactWebsite }}</a></p> -->
          <p *ngFor="let website of rep.LocalContactWebsite" id="{{'repwebsite' + i}}" class="mb-0 show"><a
              href="{{website}}" target="_blank" class="ps-0">{{ website }}</a></p>
          <p>{{ rep.LocalContactPhone }}</p>
          <p class="lead fw-bold mb-0"><u>{{ 'LOCATEAPARTNER.VEEXC' | translate }}</u></p>
          <p class="mb-0">{{ rep.VeEXContactName }}</p>
          <span class="mb-0 align-middle" [innerHTML]="rep.VeEXContactEmail"></span>
          <p class="mb-0">{{ rep.VeEXContactPhone }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
